import { createContext } from 'react';

const AuthContext = createContext({
  currentUser: null,
  isAuthenticated: false,
  loading: true,
  setCurrentUser: () => {},
  signIn: () => {},
  signOut: () => {},
  reset: () => {}
});

export default AuthContext;